import React, { useEffect, useMemo, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import LoginContantData from "../../../components/loginContantData/LoginContantData";
import { Link } from "react-router-dom";
import OTPField from "./OTPField";
import { useSelector, useDispatch } from "react-redux";
import { handleDark } from "../../../redux/layout";
import { useNavigate, useLocation } from "react-router-dom";
import { makeRequest } from "../../../utils/makeRequest";
import * as urls from '../../../utils/urlConst';
import toastNotify from "../../../utils/toastNotify";
import { setLocalUserData, setLocalAccessToknen, setLocalRefreshToken, getBankData, setResendOtpFlag, getResendOtpFlag } from "../../../utils/common";
import { BiSun, BiMoon, BiLoader, BiPhone, BiEnvelope, BiSolidMapPin } from "react-icons/bi";
import HelpdeskIcon from "../../../components/HelpdeskIcon";
import { handleUserProfile } from "../../../redux/profile";
import { exceptionLog } from "../../../utils/common";
import { useConvertMinutesSeconds } from "../../../hooks/hooks";

const Otp = () => {
  const isDark = useSelector((state: any) => state.layout.isDark);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { state } = useLocation();
  const bankLogo = useSelector((state: any) => state.layout.bankLogo);
  const [otpValues, setOtpValues] = useState<any[]>(["", "", "", "", "", ""]);
  const joinOTP = otpValues.join();
  const OTPValues = parseFloat(joinOTP.replace(/,/g, "")).toString();
  const [emailOtpValues, setEmailOtpValues] = useState<any[]>(["", "", "", "", "", ""]);
  const emailJoinOTP = emailOtpValues.join();
  const EmailOtpValuesSend = parseFloat(emailJoinOTP.replace(/,/g, "")).toString();
  const navigate = useNavigate();
  const bankDtl: any = getBankData();

  const { convertedminutes, convertedseconds }: any = useConvertMinutesSeconds(state.response.OtpResendCount)
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(60);
  const resendFlag = getResendOtpFlag();

  useMemo(() => {
    navigate(1);
    setResendOtpFlag("N");
    setMinutes(convertedminutes);
    setSeconds(convertedseconds);
  }, [])

  useEffect(() => {
    if (state === null) {
      navigate('/')
    }
  }, [state]);

  const varifyOtp = async () => {
    try {
      setIsLoader(true);
      const payload = {
        BankCode: bankDtl.BankCode,
        Token: state.response.OtpToken,
        MobileNo: state.response.MobileNo,
        OtpCode: OTPValues,
        EmailOTPCode: !isNaN(Number(EmailOtpValuesSend)) ? EmailOtpValuesSend : "",
        Flag: state.response.Flag,
        RefNo: state.response.RefNo,
        UserName: state?.response?.UserName
      };

      const config = {};

      await makeRequest('POST', urls.otpVerify, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const { JwtToken, reFreshToken, ...response } = result.RESPONSE[0];
          setLocalUserData(response);
          setLocalAccessToknen(JwtToken);
          setLocalRefreshToken(reFreshToken);
          setResendOtpFlag("N");
          navigate("/dashboard");
          dispatch(handleUserProfile(response.Photo));
        } else if (result.STATUS === '5') {
          toastNotify(result.MESSAGE, 'success');
          navigate("/");
        } else if (result.STATUS === '9') {
          setOtpValues(["", "", "", "", "", ""]);
          setEmailOtpValues(["", "", "", "", "", ""]);
          toastNotify(result.MESSAGE, 'error');
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error) {
      await exceptionLog(error, "OTP verify", "Y");
    } finally {
      setIsLoader(false);
    }
  }

  const forgotPasswordOTPVerify = async () => {

    try {
      setIsLoader(true);

      const payload = {
        BankCode: bankDtl.BankCode,
        Token: state.response.OtpToken,
        MobileNo: state.response.MobileNo,
        OtpCode: OTPValues,
        RefNo: state.response.TranCode,
        UserName: state?.response?.UserName
      };
      const config = {};
      await makeRequest('POST', urls.forgotPasswordVerify, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, "success");
          navigate("/");
        } else {
          toastNotify(result.MESSAGE, 'error');
          setOtpValues(["", "", "", "", "", ""]);
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Forgot Password OTP verify", "Y");
      }
    } finally {
      setIsLoader(false);
    }
  };


  useEffect(() => {
    const validateOTP = () => {
      if (OTPValues.length < 6 || ((state.response.MailOTPVerifyStatus === "Y" && state.response.MailMandatoryStatus === "Y") && EmailOtpValuesSend.length < 6)) {
        return false;
      } else {
        state?.response?.Flag === "forgotPwd" ? forgotPasswordOTPVerify() : varifyOtp();
      }
    };
    validateOTP();
  }, [OTPValues.length, EmailOtpValuesSend.length, state.response.MailOTPVerifyStatus, state.response.MailMandatoryStatus]);


  // this timer for resend otp
  useEffect(() => {
    const interval = setInterval(() => {
      if (!resendFlag || resendFlag === "N") {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }

        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(interval);
          } else {
            setSeconds(59);
            setMinutes(minutes - 1);
          }
        }

        if (seconds === 0 && seconds === 0) {
          setResendOtpFlag("Y");
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [minutes, seconds]);

  const resendOtp = async () => {
    try {
      setIsLoader(true);
      const payload = {
        BankCode: bankDtl.BankCode,
        Token: state.response.OtpToken,
        MobileNo: state.response.MobileNo,
        Flag: state?.response?.Flag === "forgotPwd" ? "Login" : state.response.Flag,
        RefNo: state.response.RefNo || state.response.TranCode,
        UserName: state?.response?.UserName
      };

      const config = {};
      await makeRequest('POST', urls.loginOtpResend, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          setMinutes(convertedminutes);
          setSeconds(convertedseconds);
          setResendOtpFlag("N")
          setOtpValues(["", "", "", "", "", ""]);
          setEmailOtpValues(["", "", "", "", "", ""]);
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error) {
      await exceptionLog(error, "Resend OTP", "Y");
    } finally {
      setIsLoader(false);
    }
  }


  return (
    <>
      <div className="bg-login"></div>
      <div
        style={{ height: "100vh" }}
        className="d-flex justify-content-center align-items-center flex-column"
      >
        <Card style={{ minWidth: "350px", width: "60%" }}>
          <Card.Body>
            <Row>
              <Col md={6}
                className="d-none d-md-flex"
                style={{ flexDirection: "column", justifyContent: "center" }}
              >
                <LoginContantData />
              </Col>
              <Col sm={12} md={6}>
                <div className="py-3">
                  <div className="company-logo d-flex justify-content-center my-3">
                    <img
                      src={bankLogo.loginLogo}
                      alt="company-logo"
                      style={{ width: bankLogo.loginLogoWidth, height: bankLogo.loginLogoHeight }}
                    />
                  </div>

                  <div className="d-flex fw-bold my-4 justify-content-center gap-1">
                    <HelpdeskIcon style={{}} />
                    <h3 className="border-start border-3 ps-2 text-lg text-center">
                      OTP Verification
                    </h3>
                  </div>
                  <div className="text-xs text-slate-500 text-center">OTP has been send on your registered mobile no. ******{state?.response?.MobileNo?.substr(state?.response.MobileNo.length - 4)}</div>

                  <div className="mt-3 px-md-5">
                    <OTPField
                      name="mobileOTP"
                      otpValues={otpValues}
                      setOtpValues={setOtpValues}
                      disabled={isLoader}
                    />
                  </div>
                  {(state.response.MailOTPVerifyStatus === "Y" && state.response.MailMandatoryStatus === "Y") &&
                    <div>
                      <div className="text-xs text-slate-500 text-center mt-3">OTP has been send on your registered Email id **{state?.response.EmailId.split("@")[0].substr(state?.response.EmailId.split("@")[0].length - 4)}@{state?.response.EmailId.split("@")[1]}</div>
                      <div className="mt-3 px-md-5">
                        <OTPField
                          name="emailOTP"
                          otpValues={emailOtpValues}
                          setOtpValues={setEmailOtpValues}
                          disabled={isLoader}
                        />
                      </div>
                    </div>
                  }

                  <div className="text-center mt-2">
                    {!isLoader ? '' : <><BiLoader className='icon-loader text-lg' /> Loading...</>}
                  </div>

                  <div className="text-center mt-2">
                    {/* {resetOtp === 0 ? <Button className="text-orange border-0 bg-transparent" onClick={resendOtp}>Resend OTP</Button> : <p className="text-xs text-slate-500 text-center mt-3">You can resend OTP after this 00:{resetOtp < 10 ? `0${resetOtp}` : resetOtp}</p>} */}
                    {(resendFlag !== "Y" && (seconds > 0 || minutes > 0)) ? (
                      <p className="text-center mt-3 text-xs">You can resend OTP after this {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}</p>
                    ) : (
                      <Button className="text-orange border-0 bg-transparent text-xs" onClick={resendOtp}>Resend OTP</Button>
                    )}
                  </div>

                  <div className="text-center mt-3 text-sm">
                    <Link to="/" className='ms-1' >
                      Click here back to go login
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
            <hr />
            <div className="mb-0 text-xs text-slate-700 text-center">
              <BiPhone /> +91-{bankDtl?.MobileNo} | <BiEnvelope /> {bankDtl?.EmailId}
            </div>
            <div className="mb-0 text-xs text-slate-700 text-center" >
              <BiSolidMapPin /> Registration Address : {bankDtl?.Address}, {bankDtl?.CityName}, {bankDtl?.StateName} - {bankDtl?.PinCode}
            </div>
            <div className="mt-2">
              <p className="text-xs text-center mb-0">
                Developed by {" "}
                <Link to="https://suretytelco.com/" target="_blank">
                  SURETY-TELCO
                </Link>
                {" "} | {" "}
                Sales by {" "}
                <Link to="https://soft-techsolutions.com/" target="_blank">
                  SOFT-TECH SOLUTION
                </Link>
              </p>
              <p
                className="mt-1 text-xs text-center mb-0"
              >
                Copyrights © 2014 - {new Date().getFullYear()}
                {" "} | {" "}
                All Right Reserved
              </p>
            </div>
          </Card.Body>
        </Card>

        <div className="position-absolute d-flex align-items-center" style={{ top: 20, right: 20 }}>
          <div
            className="login-icon rounded-circle ms-2"
            onClick={() => dispatch(handleDark(!isDark))}
          >
            {isDark ? <BiSun /> : <BiMoon />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Otp;
